import { render } from "./TextEntryBox.vue?vue&type=template&id=50538c86&scoped=true"
import script from "./TextEntryBox.vue?vue&type=script&lang=js"
export * from "./TextEntryBox.vue?vue&type=script&lang=js"

import "./TextEntryBox.vue?vue&type=style&index=0&id=50538c86&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50538c86"]])

export default __exports__